import { render, staticRenderFns } from "./AdaptationPlan.vue?vue&type=template&id=09ddecde&scoped=true"
import script from "./AdaptationPlan.vue?vue&type=script&lang=js"
export * from "./AdaptationPlan.vue?vue&type=script&lang=js"
import style0 from "./AdaptationPlan.vue?vue&type=style&index=0&id=09ddecde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ddecde",
  null
  
)

export default component.exports